module.exports = __webpack_public_path__ + "static/media/item-3-6-mm-thk.b7967a4c.jpg";